
(function () {
  'use strict';

  var STORAGE_KEY = 'bb_bundle_state_v1';
  var TIERS = [
    { min: 1, percent: 0 },
    { min: 2, percent: 10 },
    { min: 3, percent: 15 },
    { min: 5, percent: 20 }
  ];

  function getTier(count) {
    if (count <= 0) return null;
    var match = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].min) match = { index: i, percent: TIERS[i].percent };
    }
    return match;
  }

  var DISCOUNT_CODES = [
    { min: 5, code: 'BUY5GET20%' },
    { min: 3, code: 'BUY3GET15%' },
    { min: 2, code: 'BUY2GET10%' }
  ];

  function getDiscountCode(count) {
    for (var i = 0; i < DISCOUNT_CODES.length; i++) {
      if (count >= DISCOUNT_CODES[i].min) return DISCOUNT_CODES[i].code;
    }
    return null;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.money_format) || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeState(items) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
    }
  }

  function initBundleBuilder(root) {
    var strings = window.BundleBuilderStrings || {};
    var items = readState();

    var progressFill = root.querySelector('[data-bb-progress-fill]');
    var filterEls = root.querySelectorAll('[data-bb-filter]');
    var cardEls = root.querySelectorAll('[data-bb-card]');
    var summaryRoot = root.querySelector('[data-bb-summary]');
    var summaryEmpty = root.querySelector('[data-bb-summary-empty]');
    var summaryFilled = root.querySelector('[data-bb-summary-filled]');
    var summaryTitle = root.querySelector('[data-bb-summary-title]');
    var summaryItemsWrap = root.querySelector('[data-bb-summary-items]');
    var summaryCount = root.querySelector('[data-bb-summary-count]');
    var summaryStruck = root.querySelector('[data-bb-summary-struck]');
    var summarySubtotal = root.querySelector('[data-bb-summary-subtotal]');
    var summaryTotal = root.querySelector('[data-bb-summary-total]');
    var ctaEmptyBtn = root.querySelector('[data-bb-cta-empty]');
    var ctaFilledBtn = root.querySelector('[data-bb-cta-filled]');
    var itemTemplate = root.querySelector('[data-bb-summary-item-template]');
    var summaryToggle = root.querySelector('[data-bb-summary-toggle]');
    var backdrop = root.querySelector('[data-bb-backdrop]');
    var scroller = root.querySelector('[data-bb-summary-scroller]');
    var scrollPrevBtn = root.querySelector('[data-bb-scroll-prev]');
    var scrollNextBtn = root.querySelector('[data-bb-scroll-next]');
    var scrollThumb = root.querySelector('[data-bb-scroll-thumb]');

    if (summaryToggle) {
      summaryToggle.addEventListener('click', function () {
        root.classList.toggle('is-bb-summary-expanded');
         document.body.classList.toggle('bundle-sticky-bar-expanded');
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        root.classList.remove('is-bb-summary-expanded');
        document.body.classList.remove('bundle-sticky-bar-expanded');
      });
    }

    /* ---------------------------- rendering ---------------------------- */
    function pluralItems(count) {
      var tpl = count === 1 ? strings.itemsOne : strings.itemsOther;
      return tpl ? tpl.replace('__COUNT__', count) : count + ' items';
    }

    function render() {
      var count = items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
      var tier = getTier(count);
      var percent = tier ? tier.percent : 0;
      var activeIndex = tier ? tier.index : -1;
      var fillPercent = activeIndex < 0 ? 2 : Math.max(2, (activeIndex / (TIERS.length - 1)) * 100);
      if (progressFill) progressFill.style.width = fillPercent + '%';
      var hasItems = items.length > 0;
      if (summaryEmpty) summaryEmpty.hidden = hasItems;
      if (summaryFilled) summaryFilled.hidden = !hasItems;
      if (summaryRoot) summaryRoot.classList.toggle('is-empty', !hasItems);
      if (ctaEmptyBtn) ctaEmptyBtn.hidden = hasItems;
      if (ctaFilledBtn) ctaFilledBtn.hidden = !hasItems;

      if (!hasItems) {
        root.classList.remove('is-bb-summary-expanded');
        document.body.classList.remove('bundle-sticky-bar-expanded');
      }

      if (summaryTitle && strings.yourBundle) {
        summaryTitle.textContent = strings.yourBundle.replace('__COUNT__', items.length);
      }

      if (summaryItemsWrap) {
        summaryItemsWrap.innerHTML = '';
        items.forEach(function (item) {
          summaryItemsWrap.appendChild(renderSummaryItem(item));
        });
      }

      updateScroller();

      var subtotalCents = items.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
      var discountCents = Math.round((subtotalCents * percent) / 100);
      var totalCents = subtotalCents - discountCents;

      if (summaryCount) summaryCount.textContent = pluralItems(count);
      if (summaryStruck) summaryStruck.hidden = discountCents <= 0;
      if (summaryStruck) summaryStruck.textContent = formatMoney(subtotalCents);
      if (summarySubtotal) summarySubtotal.textContent = formatMoney(totalCents);
      if (summaryTotal) summaryTotal.textContent = formatMoney(totalCents);

      var productIdsInBundle = {};
      items.forEach(function (i) { productIdsInBundle[i.productId] = true; });
      cardEls.forEach(function (card) {
        var badge = card.querySelector('[data-bb-card-badge]');
        if (badge) badge.hidden = !productIdsInBundle[card.getAttribute('data-product-id')];
      });

      writeState(items);
    }

    function renderSummaryItem(item) {
      var node = itemTemplate.content.firstElementChild.cloneNode(true);
      var img = node.querySelector('[data-bb-item-image]');
      if (img && item.image) {
        img.src = item.image;
        img.alt = item.title;
      } else if (img) {
        img.remove();
      }

      var titleEl = node.querySelector('[data-bb-item-title]');
      if (titleEl) titleEl.textContent = item.title.split('(')[0].trim();

      var colorEl = node.querySelector('[data-bb-item-color]');
      if (colorEl) {
        colorEl.textContent = item.color || '';
        colorEl.hidden = !item.color;
      }

      var sizeEl = node.querySelector('[data-bb-item-size]');
      if (sizeEl) sizeEl.textContent = item.size || '';

      var qtyEl = node.querySelector('[data-bb-item-qty]');
      if (qtyEl) qtyEl.textContent = item.quantity;

      var removeBtn = node.querySelector('[data-bb-item-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          removeItem(item.key);
        });
      }

      return node;
    }

    function updateScroller() {
      if (!summaryItemsWrap || !scroller) return;

      var maxScrollLeft = summaryItemsWrap.scrollWidth - summaryItemsWrap.clientWidth;
      var canScroll = maxScrollLeft > 1;
      scroller.hidden = !canScroll;
      if (!canScroll) return;

      var widthFraction = Math.min(1, summaryItemsWrap.clientWidth / summaryItemsWrap.scrollWidth);
      var scrollFraction = summaryItemsWrap.scrollLeft / maxScrollLeft;
      var leftFraction = scrollFraction * (1 - widthFraction);

      if (scrollThumb) {
        scrollThumb.style.width = (widthFraction * 100) + '%';
        scrollThumb.style.left = (leftFraction * 100) + '%';
      }
      if (scrollPrevBtn) scrollPrevBtn.disabled = summaryItemsWrap.scrollLeft <= 0;
      if (scrollNextBtn) scrollNextBtn.disabled = summaryItemsWrap.scrollLeft >= maxScrollLeft - 1;
    }

    function scrollByCard(direction) {
      if (!summaryItemsWrap) return;
      var card = summaryItemsWrap.querySelector('.bb-item-card');
      var step = card ? card.getBoundingClientRect().width + 12 : 156;
      summaryItemsWrap.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (scrollPrevBtn) scrollPrevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (scrollNextBtn) scrollNextBtn.addEventListener('click', function () { scrollByCard(1); });
    if (summaryItemsWrap) summaryItemsWrap.addEventListener('scroll', updateScroller);
    window.addEventListener('resize', updateScroller);

    function removeItem(key) {
      items = items.filter(function (i) { return i.key !== key; });
      render();
    }

    function addToBundle(data) {
      var existing = items.find(function (i) { return i.key === data.key; });
      if (existing) {
        existing.quantity += data.quantity;
      } else {
        items.push(data);
      }
      root.classList.add('is-bb-summary-expanded');
      document.body.classList.add('bundle-sticky-bar-expanded');
      render();
    }

    /* ------------------------------ filters ----------------------------- */

    filterEls.forEach(function (filterEl) {
      filterEl.addEventListener('click', function () {
        filterEls.forEach(function (el) {
          el.classList.remove('is-active');
          el.setAttribute('aria-selected', 'false');
        });
        filterEl.classList.add('is-active');
        filterEl.setAttribute('aria-selected', 'true');

        var target = filterEl.getAttribute('data-bb-filter');
        cardEls.forEach(function (card) {
          var matches = target === 'all' || card.getAttribute('data-category') === target;
          card.hidden = !matches;
        });
      });
    });

    /* ------------------------------- cards -------------------------------- */

    cardEls.forEach(function (card) {
      initCard(card);
    });

    function initCard(card) {
      var dataScript = card.querySelector('[data-bb-card-data]');
      var cardData;
      try {
        cardData = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

      var addBtn = card.querySelector('[data-bb-card-add]');
      var closeBtn = card.querySelector('[data-bb-card-close]');
      var panel = card.querySelector('[data-bb-card-panel]');
      var swatchEls = card.querySelectorAll('[data-bb-card-swatch]');
      var sizeEls = card.querySelectorAll('[data-bb-card-size]');
      var colorLabel = card.querySelector('[data-bb-card-color-label]');
      var sizeLabel = card.querySelector('[data-bb-card-size-label]');
      var qtyValueEl = card.querySelector('[data-bb-card-qty]');
      var qtyDownBtn = card.querySelector('[data-bb-card-qty-down]');
      var qtyUpBtn = card.querySelector('[data-bb-card-qty-up]');
      var submitBtn = card.querySelector('[data-bb-card-submit]');

      var selected = { color: null, size: null, qty: 1 };

      /* "Color: " / "Size: " stay put — only the value after them changes,
         between "Select Color"/"Select Size" (nothing picked yet) and the
         picked value. Reset back to the default whenever the selection is
         cleared, whether by resetPanel() or because updateOptionAvailability()
         had to drop an option that went sold out. */
      function setColorLabel(value) {
        if (!colorLabel) return;
        var displayValue = value || strings.colorLabelDefault || 'Select Color';
        colorLabel.textContent = strings.colorLabel
          ? strings.colorLabel.replace('__COLOR__', displayValue)
          : ('Color: ' + displayValue);
      }

      function setSizeLabel(value) {
        if (!sizeLabel) return;
        var displayValue = value || strings.sizeLabelDefault || 'Select Size';
        sizeLabel.textContent = strings.sizeLabel
          ? strings.sizeLabel.replace('__SIZE__', displayValue)
          : ('Size: ' + displayValue);
      }

      function resetPanel() {
        selected = { color: null, size: null, qty: 1 };
        swatchEls.forEach(function (el) { el.classList.remove('is-selected'); });
        sizeEls.forEach(function (el) { el.classList.remove('is-selected'); });
        if (qtyValueEl) qtyValueEl.textContent = '1';
        setColorLabel(null);
        setSizeLabel(null);
        updateOptionAvailability();
        updateSubmitState();
      }

      function findVariant() {
        return cardData.variants.find(function (variant) {
          var colorOk = cardData.colorOptionIndex < 0 || variant.options[cardData.colorOptionIndex] === selected.color;
          var sizeOk = cardData.sizeOptionIndex < 0 || variant.options[cardData.sizeOptionIndex] === selected.size;
          return colorOk && sizeOk;
        });
      }
      // function findVariant() {
      //   return cardData.variants.find(function (variant) {
      //     var colorOk =
      //       cardData.colorOptionIndex < 0 ||
      //       variant.options[cardData.colorOptionIndex] === selected.color;

      //     var sizeOk =
      //       cardData.sizeOptionIndex < 0 ||
      //       variant.options[cardData.sizeOptionIndex] === selected.size;

      //     return colorOk && sizeOk && variant.available;
      //   });
      // }
 

      function updateSubmitState() {
        var needsColor = cardData.colorOptionIndex > -1;
        var needsSize = cardData.sizeOptionIndex > -1;
        var ready = (!needsColor || selected.color) && (!needsSize || selected.size);
        var variant = ready ? findVariant() : null;
        var enabled = !!(variant && variant.available);
        if (submitBtn) submitBtn.disabled = !enabled;
        return variant;
      }
      // function updateSubmitState() {
      //   var needsColor = cardData.colorOptionIndex > -1;
      //   var needsSize = cardData.sizeOptionIndex > -1;
      //   if (needsColor && !selected.color) {
      //     var firstColorVariant = cardData.variants.find(function (variant) {
      //       return variant.available;
      //     });

      //     if (firstColorVariant) {
      //       selected.color = firstColorVariant.options[cardData.colorOptionIndex];

      //       swatchEls.forEach(function (el) {
      //         var value = el.getAttribute('data-value');
      //         el.classList.toggle('is-selected', value === selected.color);
      //       });

      //       setColorLabel(selected.color);
      //     }
      //   }

      //   if (needsSize && !selected.size) {
      //     var firstSizeVariant = cardData.variants.find(function (variant) {
      //       var colorMatch =
      //         !selected.color ||
      //         variant.options[cardData.colorOptionIndex] === selected.color;

      //       return variant.available && colorMatch;
      //     });

      //     if (firstSizeVariant) {
      //       selected.size = firstSizeVariant.options[cardData.sizeOptionIndex];

      //       sizeEls.forEach(function (el) {
      //         var value = el.getAttribute('data-value');
      //         el.classList.toggle('is-selected', value === selected.size);
      //       });

      //       setSizeLabel(selected.size);
      //     }
      //   }

      //   var variant = cardData.variants.find(function (variant) {
      //     var colorOk =
      //       cardData.colorOptionIndex < 0 ||
      //       variant.options[cardData.colorOptionIndex] === selected.color;

      //     var sizeOk =
      //       cardData.sizeOptionIndex < 0 ||
      //       variant.options[cardData.sizeOptionIndex] === selected.size;

      //     return colorOk && sizeOk && variant.available;
      //   });

      //   var enabled = !!variant;

      //   if (submitBtn) {
      //     submitBtn.disabled = !enabled;
      //   }

      //   return variant;
      // }

      /* ================= Sold-out color/size options: =================== */

      function updateOptionAvailability() {
        swatchEls.forEach(function (swatchEl) {
          var value = swatchEl.getAttribute('data-value');
          var available = cardData.variants.some(function (variant) {
            var colorMatch = cardData.colorOptionIndex < 0 || variant.options[cardData.colorOptionIndex] === value;
            var sizeMatch = cardData.sizeOptionIndex < 0 || !selected.size || variant.options[cardData.sizeOptionIndex] === selected.size;
            return colorMatch && sizeMatch && variant.available;
          });
          swatchEl.classList.toggle('is-unavailable', !available);
          swatchEl.disabled = !available;
          if (!available && selected.color === value) {
            swatchEl.classList.remove('is-selected');
            selected.color = null;
            setColorLabel(null);
          }
        });

        sizeEls.forEach(function (sizeEl) {
          var value = sizeEl.getAttribute('data-value');
          var available = cardData.variants.some(function (variant) {
            var sizeMatch = cardData.sizeOptionIndex < 0 || variant.options[cardData.sizeOptionIndex] === value;
            var colorMatch = cardData.colorOptionIndex < 0 || !selected.color || variant.options[cardData.colorOptionIndex] === selected.color;
            return sizeMatch && colorMatch && variant.available;
          });
          sizeEl.classList.toggle('is-unavailable', !available);
          sizeEl.disabled = !available;
          if (!available && selected.size === value) {
            sizeEl.classList.remove('is-selected');
            selected.size = null;
            setSizeLabel(null);
          }
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          cardEls.forEach(function (other) {
            if (other !== card) {
              other.classList.remove('is-open');
              var otherAdd = other.querySelector('[data-bb-card-add]');
              if (otherAdd) otherAdd.setAttribute('aria-expanded', 'false');
            }
          });
          card.classList.add('is-open');
          addBtn.setAttribute('aria-expanded', 'true');
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          card.classList.remove('is-open');
          if (addBtn) addBtn.setAttribute('aria-expanded', 'false');
        });
      }

      swatchEls.forEach(function (swatchEl) {
        swatchEl.addEventListener('click', function () {
          swatchEls.forEach(function (el) { el.classList.remove('is-selected'); });
          swatchEl.classList.add('is-selected');
          selected.color = swatchEl.getAttribute('data-value');
          setColorLabel(selected.color);
          updateOptionAvailability();
          updateSubmitState();
        });
      });

      sizeEls.forEach(function (sizeEl) {
        sizeEl.addEventListener('click', function () {
          sizeEls.forEach(function (el) { el.classList.remove('is-selected'); });
          sizeEl.classList.add('is-selected');
          selected.size = sizeEl.getAttribute('data-value');
          setSizeLabel(selected.size);
          updateOptionAvailability();
          updateSubmitState();
        });
      });

      if (qtyDownBtn) {
        qtyDownBtn.addEventListener('click', function () {
          selected.qty = Math.max(1, selected.qty - 1);
          if (qtyValueEl) qtyValueEl.textContent = selected.qty;
        });
      }
      if (qtyUpBtn) {
        qtyUpBtn.addEventListener('click', function () {
          selected.qty = selected.qty + 1;
          if (qtyValueEl) qtyValueEl.textContent = selected.qty;
        });
      }

      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          var variant = updateSubmitState();
          if (!variant) return;

          addToBundle({
            key: String(variant.id),
            variantId: variant.id,
            productId: cardData.id,
            title: cardData.title,
            image: variant.image || cardData.image,
            color: selected.color,
            size: selected.size,
            price: variant.price,
            quantity: selected.qty
          });

          card.classList.remove('is-open');
          if (addBtn) addBtn.setAttribute('aria-expanded', 'false');
          resetPanel();
        });
      }

      resetPanel();
    }

    /* -------------------------------- CTA ---------------------------------- */

    if (ctaFilledBtn) {
      ctaFilledBtn.addEventListener('click', function () {
        if (items.length === 0) return;

        ctaFilledBtn.disabled = true;
        var labelEl = ctaFilledBtn.querySelector('span');
        var defaultLabel = labelEl ? labelEl.textContent : '';
        if (labelEl && strings.ctaAdding) labelEl.textContent = strings.ctaAdding;
        var totalQuantity = items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        var discountCode = getDiscountCode(totalQuantity);

        var payload = {
          items: items.map(function (item) {
            return {
              id: item.variantId,
              quantity: item.quantity,
              properties: { _Bundle: 'Build Your Bundle' }
            };
          })
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data && data.description) {
              window.alert(data.description);
              ctaFilledBtn.disabled = false;
              if (labelEl) labelEl.textContent = defaultLabel;
              return;
            }

            writeState([]);
            var checkoutUrl = strings.checkoutUrl || '/checkout';
            if (discountCode) {
              checkoutUrl += (checkoutUrl.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(discountCode);
            }
            window.location.href = checkoutUrl;
          })
          .catch(function () {
            window.alert(strings.errorGeneric || 'Something went wrong. Please try again.');
            ctaFilledBtn.disabled = false;
            if (labelEl) labelEl.textContent = defaultLabel;
          });
      });
    }

    render();
  }

  function init() {
    var roots = document.querySelectorAll('[data-bb-root]');
    roots.forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
